import React from "react";
import { Crown, Feather, Drama, Coins, Anchor, ScrollText, Megaphone, Wallet, Flag } from "lucide-react";

// Classic officer crests — GM is rank #1 and owns the whole Mess.
export const CRESTS = {
  "GM": { rank: 1, label: "Grand Master", icon: Crown, from: "#D4AF37", to: "#8A6508", ring: "#FFE9A6" },
  "Penmate": { rank: 2, label: "Penmate", icon: Feather, from: "#B8860B", to: "#6B4E00", ring: "#F6DE8C" },
  "Mascot": { rank: 3, label: "Mascot", icon: Drama, from: "#C0392B", to: "#6E1B13", ring: "#F5B7B1" },
  "Galleon Purse": { rank: 4, label: "Galleon Purse", icon: Coins, from: "#1F8A70", to: "#0B4A3B", ring: "#A6E3D0" },
  "Frigate Captain": { rank: 5, label: "Frigate Captain", icon: Anchor, from: "#0E7D96", to: "#073F4C", ring: "#A9DDE8" },
  "Scribe": { rank: 6, label: "Scribe", icon: ScrollText, from: "#5B4B8A", to: "#2E2447", ring: "#CFC4EC" },
  "Crier": { rank: 7, label: "Crier", icon: Megaphone, from: "#D35400", to: "#6E2C00", ring: "#F8CBA6" },
  "Purse": { rank: 8, label: "Purse", icon: Wallet, from: "#2E86C1", to: "#154360", ring: "#AED6F1" },
  "FC": { rank: 9, label: "FC", icon: Flag, from: "#616A6B", to: "#2C3E50", ring: "#D5DBDB" },
};

export function isOfficerPosition(p) { return !!CRESTS[p]; }

// Shield-shaped crest. size: px
export default function Crest({ position, size = 28, showRank = true, className = "" }) {
  const c = CRESTS[position];
  if (!c) return null;
  const Icon = c.icon;
  const id = `crest-${position.replace(/\s+/g, "-")}`;
  return (
    <span className={`relative inline-flex shrink-0 items-center justify-center ${className}`} style={{ width: size, height: size * 1.15 }} title={`${c.label} · Rank #${c.rank}`} data-testid={`crest-${position.replace(/\s+/g, "-").toLowerCase()}`}>
      <svg viewBox="0 0 100 115" width={size} height={size * 1.15} className="absolute inset-0 drop-shadow">
        <defs><linearGradient id={id} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor={c.from} /><stop offset="1" stopColor={c.to} /></linearGradient></defs>
        <path d="M50 3 L92 16 V58 C92 84 72 102 50 112 C28 102 8 84 8 58 V16 Z" fill={`url(#${id})`} stroke={c.ring} strokeWidth="4" />
        <path d="M50 14 L82 24 V57 C82 77 67 92 50 100 C33 92 18 77 18 57 V24 Z" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="2" />
      </svg>
      <Icon className="relative text-white" style={{ width: size * 0.5, height: size * 0.5 }} strokeWidth={2.2} />
      {showRank && <span className="absolute -bottom-1 -right-1 flex items-center justify-center rounded-full border border-white bg-[#0A192F] font-bold text-[#FFE9A6]" style={{ width: size * 0.5, height: size * 0.5, fontSize: size * 0.3 }}>{c.rank}</span>}
    </span>
  );
}

export function CrestBadge({ position, className = "" }) {
  const c = CRESTS[position];
  if (!c) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[0.65rem] font-700 ${className}`} style={{ borderColor: c.ring, background: `${c.from}22`, color: c.to }} data-testid={`crest-badge-${position.replace(/\s+/g, "-").toLowerCase()}`}>
      <Crest position={position} size={16} showRank={false} />{c.label} · #{c.rank}
    </span>
  );
}
